const loginScreenBgImage = "/images/auth/login-screen-bg.jpg"
const verificationScreenBgImage = "/images/auth/verification-screen-bg.jpeg"
const authCircleSvg = "/images/auth/auth-bg-circle.svg"
const sigUpScreenBgImage = "/images/auth/sign-up-screen-bg.jpeg"
const forgotPasswordScreenBgImage = "/images/auth/forgot-password-screen-bg.jpeg"
const successCheckIconSvg = "/images/auth/success-check.svg"
const successScreenBgImage = "/images/auth/success-screen-bg.jpeg"
const successfullySentBgImage = "/images/auth/successfully-sent-bg.jpeg"
const createNewPasswordScreenBgImage = "/images/auth/change-password-screen-bg.jpeg"

export {
    loginScreenBgImage,
    verificationScreenBgImage,
    authCircleSvg,
    sigUpScreenBgImage,
    forgotPasswordScreenBgImage,
    successCheckIconSvg,
    successScreenBgImage,
    successfullySentBgImage,
    createNewPasswordScreenBgImage,
}